import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const FooterStyle = styled.footer`
  background: #151515;
  color: #fff;
  font-family: sans-serif;
  min-height: 427px;
  padding-bottom: 48px;
  /* width: 1440px; */
  /* padding: 100px 120px 48px 120px; */

  /* @media (max-width: 1280px) {
    width: 1280px;
  } */

  @media (max-width: 780px) {
    /* padding: 56px 16px 48px 16px; */
  }

  @media (max-width: 600px) {
    padding-bottom: 48px;
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 64.25px;
  align-items: baseline;
  /* justify-content: left; */
  justify-content: center;
  padding: 100px 34px 56px 34px;
  flex-wrap: wrap;

  @media (max-width: 1280px) {
    justify-content: left;
  }

  @media (max-width: 600px) {
    padding: 50px 17px 56px 17px;
    /* flex-wrap: wrap; */
    /* align-items: center; */
  }

  @media (max-width: 540px) {
    justify-content: left;
  }

  @media (max-width: 440px) {
    justify-content: left;
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  /* flex: 1 100px; */
  gap: 24px;
  margin: 10px;
`;

export const Socials = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const OutLink = styled.a`
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.8;
  }

  img {
    transition: opacity 0.3s ease;
  }

  &:hover img {
    opacity: 0.8;
  }
`;

export const ContactEmail = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const ContactLink = styled.a`
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  color: #d1d1d1;
  transition: color 0.8s ease;

  &:hover {
    color: #f6f6f6;
  }
`;

export const ContactTel = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const TelText = styled.a`
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  color: #fff;
  transition: color 0.8s ease;

  @media (max-width: 440px) {
    font-size: 14px;
  }

  &:hover {
    color: #f6f6f6;
  }
`;

export const Text = styled.p`
  /* font-family: Open Sans; */
  text-align: left;
  width: 282px;
  line-height: 21.79px;
  font-weight: 400;
  font-size: 16px;
  color: #d1d1d1;
`;

export const TextHeader = styled.h3`
  font-size: 28.43px;
  font-weight: bold;
  line-height: 34.12px;
  letter-spacing: -0.03em;
  text-align: left;
`;

export const ListItems = styled.ul`
  line-height: 21.79px;
  background-color: blue;
`;

export const ListItem = styled.li`
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  list-style: none;
  line-height: 21.79px;
  color: #d1d1d1;
  list-style-position: inside;
`;

export const StyledNavLink = styled(NavLink)`
  font-size: 16px;
  text-decoration: none;
  color: #d1d1d1;
  transition: color 0.8s ease;

  &:hover {
    color: #f6f6f6;
  }
`;
export const MobileStore = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StoreLink = styled.a`
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.8;
  }

  img {
    transition: opacity 0.3s ease;
  }

  &:hover img {
    opacity: 0.8;
  }
`;

export const MobileStoreImg = styled.div`
  width: 175px;
  height: 49px;
`;

export const CopyrightText = styled.p`
  /* padding-bottom: 48px; */
  font-size: 16px;
  font-weight: 400;
  color: #6d6d6d;
  text-align: center;
  height: 22px;

  @media (max-width: 600px) {
    font-size: 12px;
  }

  @media (max-width: 440px) {
    text-align: left;
    padding-left: 17px;
  }
`;
